import { render } from "./a-settings.vue?vue&type=template&id=2664af2c&scoped=true"
import script from "./a-settings.vue?vue&type=script&lang=js"
export * from "./a-settings.vue?vue&type=script&lang=js"

import "./a-settings.vue?vue&type=style&index=0&id=2664af2c&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2664af2c"]])

export default __exports__